import { Box, IconButton, TableCell, TableRow, Tooltip, Typography, useTheme } from '@mui/material'
import React from 'react'

import { useResumeBuilderStore } from '../../../store/resumebuilder.store'
import { Icons } from '../../../utils/utilities'
import { toast } from 'react-toastify'
import api from '../../../service/api'
import CustomChip from '../../common/CustomChip'

const EntitiesTableRow = ( { item, setSelectedEntity } ) => {

    const ResumeBuilderStore = useResumeBuilderStore()
    const { palette } = useTheme()

    const deleteEntity = async () => {
        try {
            await api.deleteResumeEntity( item.id )
            await ResumeBuilderStore.fetchEntities()
        } catch ( err ) {
            console.log( err )
            toast( ( err.response && err.response.data ) ? err.response.data.message : "Something went wrong!" )
        }
    }

    return (
        <TableRow className='table-row' sx={{ "&:hover": { background: palette.rowHover } }}>
            <TableCell sx={{ padding: "5px 20px", fontWeight: "600" }}>
                <Box>
                    {item.entity_name}
                    <Typography fontSize="12px"><em>{item.description}</em></Typography>
                </Box>
            </TableCell>
            <TableCell sx={{ padding: "10px 20px" }}> <CustomChip value={item.entity_detail.key} /> </TableCell>
            <TableCell sx={{ padding: "10px 20px" }}>{item.entity_detail.label}</TableCell>
            <TableCell sx={{ padding: "10px 20px" }} align='center' >
                {item.entity_detail.label_show ? Icons.default.CheckCircleIconOutlined : Icons.default.CancelIcon}
            </TableCell>
            <TableCell sx={{ padding: "10px 20px", textTransform: "capitalize" }} >{item.entity_detail.data_type}{item.entity_detail.longText !== false && item.entity_detail.longText === true && "(long)"}</TableCell>
            <TableCell sx={{ padding: "5px 20px" }}>
                <Box display="flex" justifyContent="flex-end" alignItems="center" gap="10px">
                    <Tooltip title="Edit Entity" placement='top-start'>
                        <IconButton onClick={() => setSelectedEntity( item )} size='small' color='secondary'>
                            {Icons.default.EditIcon}
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete Entity" placement='top-start'>
                        <IconButton onClick={deleteEntity} size='small' color='error'>
                            {Icons.default.DeleteIcon}
                        </IconButton>
                    </Tooltip>
                </Box>
            </TableCell>
        </TableRow>
    )
}

export default EntitiesTableRow
